<template>
  <div class="bg_gray">
    <div class="fixed">
      <div class="top_header top_sm">
        <div class="m_flex_box flex_vc flex_jz top_normal">
          <van-icon name="arrow-left" @click="$router.go(-1)" />
          <p>青年人才购房券查询</p>
        </div>
      </div>
    </div>
    <div class="pad_top"></div>
    <van-form @submit="onSubmit" validate-trigger="onSubmit">
      <div class="main_ bor_b">
        <div>
          <van-field
            readonly
            clickable
            name="picker"
            :value="formData.districtName"
            label="申请区域"
            placeholder="请选择"
            @click="showArea = true"
          />
          <van-popup v-model="showArea" position="bottom">
            <van-picker
              show-toolbar
              value-key="t"
              :columns="appAreaList"
              @confirm="onConfirmArea"
              @cancel="showArea = false"
            />
          </van-popup>
        </div>
        <div>
          <van-field
            readonly
            clickable
            name="picker"
            :value="formData.applyType"
            label="申请类型"
            placeholder="请选择"
            @click="showType = true"
          />
          <van-popup v-model="showType" position="bottom">
            <van-picker
              show-toolbar
              value-key="t"
              :columns="appTypeList"
              @confirm="onConfirmType"
              @cancel="showType = false"
            />
          </van-popup>
        </div>
        <van-field
          v-model="formData.applyName"
          name="realName"
          label="申请人"
          placeholder="请输入申请人姓名"
        />
        <van-field
          v-model="formData.cardNo"
          name="cardNo"
          label="证件号"
          placeholder="请输入证件号"
        />
      </div>
      <div class="btn_con">
        <van-button block type="info" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import qs from "qs";
import { Dialog } from "vant";
import topHeader from "@/components/header";
import { encode } from "punycode";
export default {
  data() {
    return {
      appAreaList: [
        {
          t: "云龙区",
        },
        {
          t: "鼓楼区",
        },
        {
          t: "泉山区",
        },
        {
          t: "港务区",
        },
        {
          t: "经开区",
        },
        {
          t: "铜山区",
        },
        {
          t: "贾汪区",
        },
      ],
      appTypeList: [
        {
          t: "博士",
        },
        {
          t: "硕士",
        },
        {
          t: "本科",
        },
        {
          t: "大专",
        },
        {
          t: "正高级职称",
        },
        {
          t: "副高级职称",
        },
        {
          t: "中级职称",
        },
        {
          t: "高级技师",
        },
        {
          t: "技师",
        },
      ],
      appArea: "",
      appType: "",
      showArea: false,
      showType: false,
      formData: {
        districtName: "",
        applyType: "",
        applyName: "",
        cardNo: "",
        pageSize: 10,
        pageIndex: 1,
      },
    };
  },
  mounted() {},
  methods: {
    onConfirmArea(data) {
      this.formData.districtName = data.t;
      this.$set(this.formData, "districtName", data.t);
      this.showArea = false;
    },
    onConfirmType(data) {
      this.formData.applyType = data.t;
      this.showType = false;
    },

    onSubmit() {
      this.$router.push({
        path: "/personPublicity",
        query: {
          districtName: encodeURIComponent(
            encodeURIComponent(this.formData.districtName)
          ),
          applyType: encodeURIComponent(
            encodeURIComponent(this.formData.applyType)
          ),
          applyName: encodeURIComponent(
            encodeURIComponent(this.formData.applyName)
          ),
          cardNo: this.formData.cardNo,
        },
      });

      // if (this.formData.appType == 1) {
      //   if (!this.bargainor) {
      //     this.$toast("请输入出卖方姓名!");
      //   }
      //   if (!this.purchaser) {
      //     this.$toast("请输入买受方姓名!");
      //   }
      //   if (!this.ownerNo) {
      //     this.$toast("请输入权属证号!");
      //   }
      //   if (!this.houseAddress) {
      //     this.$toast("请输入交易房屋地址!");
      //   }
      const formData = new FormData();
      formData.append("districtName", this.formData.districtName);
      formData.append("applyType", this.formData.applyType);
      formData.append("applyName", this.formData.applyName);
      formData.append("cardNo", this.formData.cardNo);
      formData.append("pageSize", 10);
      formData.append("pageIndex", 1);
      // this.$http
      //   .post({
      //     url: "house/api/ysbm/talentPublicityList.do",
      //     method: "POST",
      //     headers: {
      //       "Content-Type": "application/json",
      //     },
      //     data: this.formData,
      //   })
      //   .then((res) => {
      //     if (res.success) {
      //       this.$toast(res.msg);
      //       this.$router.go(-1);
      //     } else {
      //       this.$toast(res.msg);
      //     }
      //   });
      this.$http({
        url: "house/api/ysbm/talentPublicityList.do",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: formData,
      }).then((res) => {
        if (res.success) {
        } else {
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.bg_gray {
  background-color: #f5f5f5;
  min-height: 100vh;
}

.top_header {
  height: 0.7rem;
  padding: 0.2rem 0rem;
  width: 7.04rem;
  margin: 0 auto;

  &.top_sm {
    padding: 0.1rem;
  }
}

.pad_top {
  padding-top: 0.9rem;
}

.fixed {
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;
  border-bottom: 1px solid #f5f5f5;

  .top_normal {
    height: 100%;

    p {
      font-size: 0.32rem;
    }

    i {
      font-size: 0.32rem;
    }

    .right {
      font-size: 0.28rem;
      color: #2f72f5;
    }
  }
}

.btn_con {
  background-color: #fff;
  z-index: 9;
  padding: 0.4rem 0;
  left: 0;
  right: 0;

  /deep/ .van-button {
    height: 0.88rem;
    width: 7.04rem;
    margin: 0 auto;
    border-radius: 0.08rem;
  }
}

.blue_con {
  background-color: #eff4ff;
  color: #2f72f5;
  width: 7.04rem;
  box-sizing: border-box;
  padding: 0.24rem 0.23rem;
  margin: 0 auto 0;
  border-radius: 0.08rem;

  h4 {
    font-weight: 800;
    font-size: 0.26rem;
    margin-bottom: 0.1rem;
  }

  p {
    font-size: 0.24rem;
    line-height: 0.4rem;
  }
}

.main_b {
  padding-top: 0.3rem;
  background-color: #fff;
}

.wrapper {
  height: 9.54rem;
  width: 6.64rem;
  background-color: #fff;

  h5 {
    padding-top: 0.88rem;
    font-size: 0.38rem;
    text-align: center;
    font-weight: 800;
    margin-bottom: 0.5rem;
  }

  .content_ {
    height: 60%;
    box-sizing: border-box;
    padding: 0 0.4rem 0;
    overflow: auto;
    font-size: 0.28rem;

    p {
      margin-bottom: 0.35rem;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .btn {
    width: 2.92rem;
    line-height: 0.82rem;
    text-align: center;
    color: #fff;
    background-color: #2f72f5;
    border-radius: 0.08rem;
    font-size: 0.28rem;
    margin: 0.45rem auto 0;
  }
}

.opc_cover {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 2;
}
</style>
